/* Copyright (c) 2018 Scaper */

import * as cx from "classnames";
import * as React from "react";

import "./fullScreenModal.scss";

interface IState {
    hasChildren: boolean;
    mounted: boolean;
}

export class FullScreenModal extends React.PureComponent<{}, IState> {
    public state: IState = {
        hasChildren: false,
        mounted: false,
    };

    private readonly ref = React.createRef<HTMLDivElement>();

    public render() {
        const { children } = this.props;
        const { hasChildren, mounted } = this.state;
        const className = cx(
            "scpr-FullScreenModal z-depth-4",
            { "scpr-FullScreenModal-has-children": hasChildren },
            { "scpr-FullScreenModal-is-mounted": mounted },
        );
        return (
            <div className={className}>
                <div className="container" ref={this.ref}>
                    {children}
                </div>
            </div>
        )
    }

    public componentDidMount() {
        const { current } = this.ref;
        if (current != null && current.innerHTML != null && current.innerHTML !== "") {
            this.setState({ hasChildren: true });
        }

        setTimeout(() => {
            this.setState({ mounted: true });
        }, 1000);
    }

    public componentDidUpdate(_prevProps: {}, prevState: IState) {
        const { current } = this.ref;
        const { hasChildren: prevHasChildren } = prevState;
        if (current != null && current.innerHTML != null && current.innerHTML !== "") {
            if (prevHasChildren === false) {
                this.setState({ hasChildren: true });
            }
        } else {
            if (prevHasChildren === true) {
                this.setState({ hasChildren: false });
            }
        }
    }
}
